import { render, staticRenderFns } from "./GradientColorPicker.vue?vue&type=template&id=0c8574ac&scoped=true"
import script from "./GradientColorPicker.vue?vue&type=script&lang=js"
export * from "./GradientColorPicker.vue?vue&type=script&lang=js"
import style0 from "./GradientColorPicker.vue?vue&type=style&index=0&id=0c8574ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8574ac",
  null
  
)

export default component.exports